import React, { useState } from "react";

// react query
import { useQueryClient } from "react-query";

// use custom hook
import { useInsertDetailOrderProduct } from "../../hooks/useAccounting";

// components
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";

// react icons
import { CgClose } from "react-icons/cg";

// styled components
import styled from "styled-components";
import { Wrapper } from "../../theme/GlobalStyle";
import Typography from "../Typography/Typography";

const AddProductDialog = ({
  handleClose,
  idOrderOnline,
  setIsShowAddModal,
  products,
  show,
}) => {
  const [productData, setProductData] = useState({
    NumberSeller: "",
    IdProducts: "",
    IdOrderOnline: idOrderOnline,
  });

  const [searchTerm, setSearchTerm] = useState("");

  const queryClient = useQueryClient();

  const { mutateAsync } = useInsertDetailOrderProduct();

  const handleSubmit = async () => {
    await mutateAsync(productData);
    queryClient.invalidateQueries(["detail-online-order", idOrderOnline]);
    setIsShowAddModal(false);
  };

  return (
    <BootstrapModal
      modaltitle="اضافه کردن محصول"
      handleClose={handleClose}
      show={show}
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
      // moreButton={!showCrmButton}
    >
      {/* <FormGroup> */}
      <Wrapper between="between">
        <div className="row">
          <div className="col-6">
            <InputField1
              name="NumberSeller"
              label="جستجو :"
              onChange={(event) => setSearchTerm(event.target.value)}
            />
          </div>
          <div className="col-6">
            <InputField1
              name="NumberSeller"
              label="تعداد :"
              onChange={(e) =>
                setProductData({
                  ...productData,
                  NumberSeller: e.target.value,
                })
              }
            />
          </div>
        </div>
      </Wrapper>
      <ListImages>
        {products
          ?.filter((product) => {
            if (searchTerm === "") {
              return product;
            } else if (product?.NameProducts?.includes(searchTerm)) {
              return product;
            }
          })
          ?.map((product) => {
            return (
              <ProductCard key={product.IdProducts}>
                <img
                  src={`https://apisalamat.mahanskinclinic.com/thumbnail/Product/${product?.PhotoProducts}`}
                />
                <ProductFooter>
                  <div className="d-flex">
                    <div className="mx-2">
                      <input
                        type="radio"
                        name={product.IdProducts}
                        onChange={(e) =>
                          setProductData({
                            ...productData,
                            IdProducts: e.target.value,
                          })
                        }
                        value={product.IdProducts}
                        // checked={product.IdProducts === product.IdProducts}
                      />
                    </div>

                    <span style={{ color: "#fff" }}>انتخاب محصول</span>
                  </div>
                  <Typography size="14px" primary="#fff">
                    {product?.NameProducts}
                  </Typography>
                  <Typography size="14px" primary="#fff">
                    {product?.CodeProducts}
                  </Typography>
                </ProductFooter>
              </ProductCard>
            );
          })}
      </ListImages>
      <Wrapper>
        <Button
          size="14px"
          spaceLeft=".5rem"
          bgColor="#28A745"
          color="#fff"
          onclick={handleSubmit}
        >
          تایید
        </Button>
        <Button
          size="14px"
          bgColor="#DC3545"
          color="#fff"
          onclick={handleClose}
        >
          منصرف شدم
        </Button>
      </Wrapper>
    </BootstrapModal>
  );
};

const ListImages = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1rem;
  height: 400px;
  overflow-y: auto;
  img {
    width: 100%;
    height: 150px;
    object-fit: cover;
  }
`;

const ProductCard = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem;
  box-shadow: ${({ theme }) => theme.shadow};
  padding: 0.2rem;
  width: 200px;
`;

const ProductFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.2rem;
  background-color: #138496;
  padding: 0.2rem;
  flex-direction: column;
  span {
    font-size: 12px;
    font-weight: bold;
  }
`;

export default AddProductDialog;
